import { sessionApiClient } from "@planningcenter/cc-api-client"
import { loadStripe } from "@stripe/stripe-js"
import {
  Config,
  DateStampString,
  DraftFrequency,
  StripeCustomerSessionClientSecret,
} from "./types"
import { frequencyToSchedule } from "./utils/frequency"

export async function fetchStartDates(
  frequency: DraftFrequency,
): Promise<DateStampString[]> {
  const schedule = frequencyToSchedule(frequency)
  const response = await sessionApiClient.post(
    "/giving/v2/recurring_donation_start_dates",
    { data: { attributes: { schedule } } },
  )
  return response.data.attributes.occurrences
}

// CSC: Customer Session Client
async function fetchStripeCSCSecret(): Promise<StripeCustomerSessionClientSecret> {
  // TODO: these are to verify that we are not refetching unnecessarily,
  // probably want to remove before launch?
  console.debug("Fetching stripe csc secret")
  const response = await sessionApiClient.post(
    "/giving/v2/me/stripe_customer_session",
  )
  return response.data.attributes.client_secret
}
export function fetchStripeCSCSecretQuery() {
  return {
    queryKey: ["DonationForm", "stripeCustomerSessionClientSecret"],
    queryFn: fetchStripeCSCSecret,
    staleTime: Infinity,
  }
}

async function fetchStripeObject(config: Config) {
  // TODO: these are to verify that we are not refetching unnecessarily,
  // probably want to remove before launch?
  console.debug("Fetching stripe object")
  return await loadStripe(config.stripe_publishable_key, {
    stripeAccount: config.stripe_account_identifier,
  })
}
export function fetchStripeObjectQuery(config: Config) {
  return {
    queryKey: [
      "DonationForm",
      "stripeObject",
      config.stripe_publishable_key,
      config.stripe_account_identifier,
    ],
    queryFn: () => fetchStripeObject(config),
    staleTime: Infinity,
  }
}
